import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { getRefCompIdFromInflatedId } from '@wix/thunderbolt-commons'
import { EditorFeatureConfigSymbol, ViewerManagerDataAPISymbol } from '@wix/thunderbolt-symbols'
import type { IViewerManagerImplementor, ViewerAPI, DataMapName } from 'thunderbolt-viewer-manager-types'
import type { ViewerManagerByRefApiEditorConfig } from './types'
import { name } from './symbols'

export const ViewerManagerByRefApi = withDependencies(
	[named(EditorFeatureConfigSymbol, name), ViewerManagerDataAPISymbol],
	(
		config: ViewerManagerByRefApiEditorConfig,
		{ data: dataViewerApi }: ViewerAPI
	): IViewerManagerImplementor<'byRef'> => ({
		byRef: {
			getData: (dataType, id) => dataViewerApi.getData(dataType as DataMapName, id),
			getStructure: (id) => config.byRefModel.resolvedRefStructure[id],
			// we are not going to implement getRemoteOverrides(), it belongs to deprecated flow
			getRemoteOverrides: () => [],
			getDisplayedConnectionOverrides: (compId: string) =>
				config.byRefModel.displayedConnectionOverrides[getRefCompIdFromInflatedId(compId)]?.[compId],
			getHiddenCompsGroupedByRefComponent: (refId) => config.byRefModel.hiddenCompsGroupedByRefComponent[refId],
			getInternallyReferredComps: (refId) => config.internalRefIdToInflatedIds[refId],
		},
	})
)
